<template>
  <!-- class="w-full mx-auto bg-white rounded-t-xxl md:overflow-auto md:h-screen md:pb-80 pb-10 px-4" -->
  <div
    class="w-full mx-auto bg-white rounded-t-xxl overflow-auto h-screen md:pb-80 pb-40 px-4"
    :style="makeStyles(hasKiosk && mainSectionTopRadius, orderDetailPageBackground)"
  >
    <div
      class="flex justify-center pt-4 flex-col"
      v-if="orderData.orderStatus != 'PaymentFailed'"
    >
      <!-- <img src="../assets/images/thank-you.svg" /> -->
      <p
        class="text-4xl text-product-gray text-center mt-10"
        :style="orderDetailSuccesfullPayment"
        v-if="
          hasKiosk &&
          orderData.orderStatus != 'PaymentFailed' &&
          orderData.orderStatus != 'PaymentPending'
        "
      >
        {{ lang["thank_you_message"][language] }}
      </p>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 864 864"
        style="enable-background: new 0 0 864 864"
        xml:space="preserve"
        :class="[
          'md:w-3/12 w-1/3 lg:w-2/12 h-24 mx-auto',
          hasKiosk
            ? 'thankyouicon mb-24  mt-24'
            : 'lg:h-32',
        ]"
      >
        <g :fill="thankYouImgColor">
          <path
            class="st0"
            d="M226.5,429c0.1-2.5,0.1-4.9,0.3-7.4c1.2-18.9,4.5-37.5,7.8-56.1c6-30.7,12.7-61.2,19.8-91.6
		c1.3-5.9,2.7-11.8,4-17.7c7.6-1.5,15.3-2.7,23-3.6c-6.6,29.4-11.4,59.2-15.8,89c-3,20.7-5.4,41.5-8.2,62.3
		c-0.4,2.8-0.7,5.6-1.2,8.4c-0.4,1.3-0.7,2.6-1.1,4.1c-0.3,1.2-1.7,6.8-1.7,8.2c0,2.4-1.6,6.4,0.7,7.2c7.7,2.8,16.4,1.2,24.6,1.8
		c0.5-1.1,1-2.3,1.4-3.4c0.5-1.6,1-4.6,1.3-6.1c0.3-1.9,0.6-3.9,0.9-5.8c0.5-1.6,1-3.2,1.6-5.1c5.1-15.9,12.3-31,20.2-45.7
		c5.8-10.5,12.7-20.3,20-29.8c-0.9,4.7-1.8,9.4-2.6,14.1c-3.2,18.4-6.4,36.8-8.2,55.3c-0.4,3.7-0.6,7.4-0.9,11.1
		c-1,16.5-1.1,33.2,2.2,49.5c0.6,2.7,1.3,5.4,2,8.1c2.3,7.7,5.6,15,11.6,20.5c1.8,1.7,4.1,2.9,6.1,4.4c16,10.2,30.4-12.4,14.4-22.6
		c-0.3-0.1-0.7,0-1-0.2c-3.2-1.5-3.9-5.8-5.1-8.6c-0.5-2-1.1-4-1.5-6.1c-3-14.1-2.7-28.6-1.9-42.9c0.3-3.4,0.5-6.9,0.8-10.3
		c1.7-17.9,4.8-35.7,7.9-53.5c2.7-14.5,5.6-28.9,7.9-43.4c0.5-4.5,1.7-12.5-0.8-16.5c-2-3.2-4.5-6.5-7.9-8.1
		c-6.8-3.2-10-0.7-15.1,1.7c-1,0.7-2,1.4-2.9,2.2c-6.9,5.6-12.4,12.6-18.2,19.2c-5.9,7.1-11.6,14.5-16.9,22
		c3.8-25.2,8.1-50.3,13.6-75.1c0.7-3.3,1.5-6.5,2.2-9.7c4-0.7,8-1.5,12-2.6c11.7-3.2,23.3-7,33.8-13.3c3.8-2.4,5.8-3.5,9.4-6.3
		c6-4.6,11.3-10.2,15.5-16.5c1-1.6,2-3.2,2.9-4.8c4.5-8.1,7.4-17.1,8.8-26.3c0.2-1.9,0.5-3.7,0.7-5.6c0.7-8.4,0.3-17-1.9-25.2
		c-0.5-1.5-0.8-3-1.4-4.5c-2.4-6.7-6.3-12.6-11.9-17c-1.2-0.8-2.3-1.6-3.5-2.3c-5.7-3.3-12.2-4.5-18.6-4c-6.2,0.8-12.3,2.3-17.7,5.4
		c-4.4,2.6-8.5,5.7-12,9.6c-3.5,3.7-7,7.5-10.1,11.5c-2.6,3.5-5.1,7-6.6,11.1c-0.8,2.3-1.5,4.7-2.1,7.2c-1.8,4.4-3.4,8.8-5,13.2
		c-5.5,15.2-10,30.8-13.9,46.5c-2.6,0.3-5.1,0.6-7.7,0.9c-5.2,0.5-10.3,1.3-15.5,2.1c1.8-8,3.6-16.1,5.3-24.1
		c2.2-10.4,4.8-20.9,5.3-31.6l0,0c0.2-18.9-26.5-19.3-26.8-0.3c-0.8,8.9-2.9,17.7-4.8,26.4c-2.5,11.8-5.2,23.6-7.8,35.4
		c-12.3,3.2-24.3,7.6-36,12.5c-10.6,4.6-20.5,10.4-30,17c-7.8,5.2-13.8,12.3-19.3,19.8c-5.1,7-9.1,14.7-12.7,22.5
		c-3.8,8.1-5.5,16.9-6.5,25.8c-0.6,7.1-0.4,14.4,1.2,21.4c0.3,1.4,0.7,2.7,1.1,4.1c1.9,5,0.9,2.6,3,7.2c8.4,17,32.4,5.2,24-11.8
		c-0.9-1.8-0.5-0.8-1.3-2.7c-1.6-4.9-1.8-10.2-1.5-15.3c0.6-6,1.7-11.9,4.2-17.5c2.8-6.2,6-12.2,9.9-17.7c3.8-5.1,7.6-10.1,13-13.7
		c7.9-5.5,16.3-10.4,25.2-14.3c6.2-2.6,12.4-5,18.7-7.2c-0.3,1.4-0.7,2.9-1,4.3c-7.1,30.7-13.9,61.5-20,92.4
		c-3.5,19.5-7,39.2-8.2,59c-0.2,2.8-0.2,5.7-0.4,8.5c0.1,9.4-0.1,4.9,0.4,13.3c1.1,18.9,27.8,17.4,26.7-1.5
		C226.5,433,226.6,436.5,226.5,429z M351.4,148.9c2.3-1.2,4.8-1.6,7.3-1.9c1.2,0.1,2.6,0.4,3.4,1.5c1.8,2,2.5,4.6,3.2,7.1
		c1.7,6.6,1.3,13.3,0.4,20c-1.1,7.4-4,14.1-8,20.4c-4.1,6.2-10,10.3-16.2,14.1c-7.6,4.4-15.9,7.2-24.3,9.5c3-10.8,6.2-21.5,10-32
		c1-2.8,2.1-5.6,3.1-8.4c1.1-1.6,2-3.6,2.5-6c0,0,0-0.1,0-0.1c1.4-3.3,3-6.5,4.8-9.6l0,0c1.3-1.5,2.3-3,2.9-4.5
		c1.6-1.8,3.3-3.7,5-5.5C347.2,151.7,349.2,150.2,351.4,148.9z"
          />
          <path
            class="st0"
            d="M386.2,295.5c-1.6,1.8-3,3.7-4.6,5.6c-8.2,10.8-14.1,23-18.4,35.7c-1,2.8-1.8,5.7-2.6,8.6
		c-3.9,14.2-6.8,28.7-7.6,43.4c-0.1,2.5-0.2,5-0.2,7.5c0.2,7.7,0.4,17.3,4.6,24.1c1.3,2,2.6,4.1,4.5,5.5c2.4,1.8,5.3,2.6,8,3.9
		c3-0.1,6,0.4,8.9-0.3c4.7-1,9.3-4.5,12.7-7.6c5.6-5,10-11,14.6-16.9c3.9-5.2,7.5-10.5,10.8-16c0,0.1,0,0.1,0,0.2
		c0.7,6.4,1.3,13.7,6.1,18.7c2,2.1,4.8,3.4,7.2,5.1c16.2,7.4,27-13.6,14-22.7c0-2.4,0.1-4.7-0.5-2c-0.6-14.8,0.9-29.6,2.3-44.3
		c0.8-7.7,1.5-15.4,2.3-23.1c0.3-1.2,0.7-2.4,1-3.6c1.8-7.2,3.2-14.5,2.9-22c-2.1-9.6-1.1-10.1-20.2-9.3c-3.4-4.4-8.4-7.4-14.1-8
		c-2-0.2-4,0.1-6,0.2c-2,0.6-4.2,1.1-6.1,1.9C398.4,283.1,391.5,289.5,386.2,295.5z M409,310.5c1.3,5.4,6.1,9.4,11.4,10.1
		c-3.1,9.4-6.9,18.5-11.4,27.4c-7.1,14.1-14.8,28-24.2,40.8c-2.8,3.6-3.5,4.7-5.3,6.8c0-1.6,0-3.1,0.1-4.7
		c0.7-12.8,3.2-25.4,6.5-37.7c0.7-2.4,1.4-4.8,2.2-7.2c3.3-10,7.8-19.6,14.1-28C404.6,315.3,406.7,312.8,409,310.5z"
          />
          <path
            class="st0"
            d="M474.3,280.3c-1.5,8.8-2.5,17.6-3.4,26.5c-1.5,16.3-3.1,32.5-5.3,48.6c-0.2,1.3-0.4,2.7-0.6,4
		c-2.7,11.7-5,23.5-6.2,35.4c-0.8,11-1.6,8.4,24.1,12.2c1.9,0.3,3.3-11.3,3.6-12.7c1.7-10,3.4-19.9,4.8-29.9
		c0.3-1.1,0.5-2.2,0.8-3.4c3.3-13.2,7.4-26.3,13-38.7c1-2.3,2.1-4.5,3.2-6.8c5.5-11.1,12.1-21.5,19.8-31.2
		c-0.9,10.5-2.3,20.9-3.7,31.4c-2.4,17.3-4.8,34.6-6.7,52c-1.4,11.5-2.3,22.7-1.1,34.2c0.3,1.4,0.5,2.8,1,4.2
		c1.6,4.4,4.4,9.4,9.4,10.8c3.9,1.1,8.2,0.5,12.1-0.5c2.2-0.6,3.6-2.7,5.4-4c7.9-7.7,4.9-17.5-1.7-21.6c0-6.7,0.9-13.4,1.5-20.1
		c1.9-17.2,4.3-34.3,6.6-51.4c2.1-15.8,4.4-31.6,4.7-47.5c-0.3-5.9-0.2-13-4-18.1c-4-5.3-7.7-7.3-14.3-7.7c-2.1-0.1-4.1,0.8-6.1,1.1
		c-1.4,0.7-2.9,1.2-4.2,2c-7.3,4.1-13,10.8-18.6,16.8c-3.9,4.8-4.7,5.7-8.3,10.9c-0.1,0.1-0.1,0.2-0.2,0.3
		C495.8,266.2,477.6,265.1,474.3,280.3z"
          />
          <path
            class="st0"
            d="M560,381.2c-0.1,0.4-0.6,1-0.2,1.1c26.9,5.9,23.8,13.1,27.2,2.3c3.3-9.6,7.8-18.7,12.4-27.7
		c2.7-5.3,5.6-10.4,8.5-15.6c0.9,3,1.9,6,3.2,8.9c0.9,2.1,2.1,4.2,3.1,6.3c6.5,11.5,15.1,21.7,25.2,30.2c2.4,2,4.9,3.8,7.3,5.8
		c15,10.6,32.3,17.7,50.6,19.8c4.1,0.5,8.3,0.4,12.4,0.7c16.8-1.1,8.6-0.1,24.7-2.7c18.7-3.1,14.3-29.5-4.3-26.4
		c-12.7,2.2-6.3,1.4-19.1,2.4c-3.1-0.1-6.2,0-9.3-0.3c-13.9-1.3-27.1-6.6-38.5-14.5c-1.9-1.5-3.9-2.9-5.7-4.4
		c-7.6-6.3-14.2-13.9-19.3-22.4c-0.7-1.4-1.5-2.7-2.1-4.1c-2.8-6-4.2-12.5-3.9-19.1c0.5-3.7,0.5-4.7,1.4-8.3
		c1.6-6.3,4.3-12.3,7.4-18c2.4-4.5,5-9,7.6-13.5c0.8-1.1,1.7-2.2,2.5-3.3c3.3-4.3,6.6-8.6,9-13.5c2.1-12.7,3.5-9-20.1-16.4
		c-1.5-0.5-7.3,8.1-8.1,9.3c-1.9,2.8-3.7,5.7-5.4,8.6c-7.4,9.5-15,19-21.7,29.1c-1.8,2.8-3.6,5.6-5.4,8.4
		c1.5-10.1,2.9-20.1,4.2-30.2c2.6-20.2,5.1-40.4,8.4-60.5c1.8-10.1,3.8-20.2,5.4-30.4l0,0c1.9-18.8-24.7-21.6-26.6-2.8
		c-1.7,9.5-3.5,19-5.2,28.5c-3.4,20.5-5.9,41.1-8.6,61.7c-2.8,21.1-5.9,42.1-9.1,63.2c-2,13.5-4.2,27-6.6,40.5
		c-0.2,1.2-0.4,2.3-0.6,3.5C559.5,384.2,560.9,376.6,560,381.2z M635.6,253.9c0,0.1-0.1,0.1-0.1,0.2c0.1-0.2,0.2-0.4,0.3-0.5
		C635.9,253.4,635.7,253.8,635.6,253.9z"
          />
          <path
            class="st0"
            d="M508,507.3c-1.5,12.1-3.6,24.1-5.1,36.2c-1.8,12.4-2.3,24.9-1.6,37.4c0.8,7.8,2.1,17.7,8.5,23.2
		c1.7,1.5,3.9,2.5,5.8,3.7c2.5,0.3,5.1,1.2,7.7,1c10-0.6,16.7-9.8,22-17.1c5.7-8.6,10.3-17.8,14.7-27.2c0.2,0.9,0.4,1.7,0.6,2.6
		c2.3,8.4,5.9,16.7,12.7,22.4c4.8,4.1,6.1,4,11.9,6.3c2.3,0.3,4.5,0.9,6.8,1c11.1,0.6,21.8-4.4,31.9-8.3c11-4.2,22.2-7.8,33.8-10.2
		c2.4-0.5,4.7-0.9,7.1-1.3c11-1.7,22.2-2.6,33.3-1.9c1.8,0.1,3.7,0.4,5.5,0.6c7.3,1.1,14.9,2.6,21,7.1c0.3,0.3,0.6,0.7,1,1
		c14.2,12.5,31.9-7.5,17.7-20.1c-1.2-1-2.5-2.1-3.7-3.1c-1.5-1-3-2-4.5-2.9c-8.8-5-18.9-7.3-28.9-8.6c-2.3-0.2-4.7-0.5-7-0.7
		c-13.1-0.8-26.3,0.3-39.2,2.3c-2.8,0.5-5.5,1-8.3,1.6c-12.7,2.7-25.2,6.6-37.3,11.3c-6.7,2.6-13.4,5.6-20.5,6.9
		c-0.5,0.1-1.1,0.2-1.6,0c-3.2-1.7-4.2-5.9-5.3-9c-0.3-1.5-0.8-3-1-4.6c-1.8-10.1-1.3-20.4-0.5-30.5c1-10.5,2.3-21,4.2-31.4
		c0.1-0.5,1.6-9.1,1.4-9.2c-18.7-9.6-22-16.1-26.7-3.7c-2.2,6.5-4.1,13.1-6.6,19.5c-5,13.1-10.3,26.2-16.1,39
		c-4.3,9.5-8.5,19-13.6,28.1c0.1-7.3,0.6-14.6,1.6-21.9c1.6-12.4,3.7-24.7,5.2-37.1c0.7-8.2,1.9-17.5-1-25.4
		c-0.7-1.8-1.6-3.5-2.5-5.3c-1.4-1.6-2.6-3.5-4.3-4.9c-6.8-5.7-16.1-5.4-24.4-4.3c-10.6,1.7-20.9,4.3-31.3,6.9
		c-0.1-0.1-0.2-0.2-0.3-0.3c-6.4-5.5-14-10.1-22.7-10.9c-1.7-0.2-3.4,0-5.1,0c-1.6,0.3-3.2,0.4-4.7,0.8c-6.1,1.7-11.7,5.7-14.7,11.3
		c-0.8,1.5-1.3,3.2-1.9,4.8c-0.2,1.8-0.7,3.7-0.6,5.5c0.2,4.6,2.1,8.9,5.1,12.3c-2.3,4.7-3.9,9.8-5.5,14.7
		c-3.4,12.5-5.8,25.4-6.5,38.4c-0.1,2.7-0.1,5.3-0.2,8c0.4,11.5,1.1,23.8,6.5,34.3c1,2,2.4,3.8,3.6,5.7c1.6,1.6,2.9,3.5,4.8,4.9
		c6.8,5.2,14.4,6.5,22.6,4c5.7-1.7,8.2-4.1,12.9-7.5c9.8-8.6,16.9-19.7,21.5-32c1-2.7,1.8-5.5,2.6-8.2c3.6-14.1,5-28.8,3.2-43.3
		c-0.3-2.7-0.9-5.3-1.3-7.9c-0.8-3.7-1.9-7.3-3.3-10.8c6.5-1.6,13-3.1,19.6-4.1c0.2,0,1-0.1,1.8-0.2c0,0.1,0,0.2,0,0.3
		C508.6,500.1,508.3,503.7,508,507.3z M463.1,554.4c-0.6,2-1.2,4-1.9,6c-2.8,7.8-7,15.2-13,21c-0.7,0.6-1.4,1.2-2,1.8
		c-0.3,0.3-0.8,0.5-0.9,0.9c-0.1,0.2-0.9,0.3-1.2-0.2c-3.8-6.3-2.8-15-3.2-22.1c0-2.1,0-4.3,0.1-6.4c0.5-11,2.6-21.8,5.4-32.5
		c1-3.1,1.7-5.7,2.9-8.7c0.6-1.5,1.3-3,2.1-4.4c0.2-0.3,0.4-0.5,0.5-0.9c0-0.1-0.1,0-0.2,0c0.7-0.5,1.2-1.1,1.8-1.7
		c2.4-0.2,4.7-0.5,7.1-0.9c1.5,2.8,2.6,5.9,3.5,9.4c0.3,1.9,0.8,3.8,1,5.7C466.7,532.5,465.7,543.7,463.1,554.4z"
          />
          <path
            class="st0"
            d="M423.2,667.1c18.6,3.5,23.6-22.8,5-26.3c-4.1-0.8-8.2-1.3-12.4-1.3c-4.4,0.2-5.7,0.1-10.1,0.9
		c-1.2,0.2-2.5,0.5-3.7,0.8c0.2-7.5,0.3-14.9,0.5-22.4c0.6-21.6,1.5-43.2,1.8-64.8c0.2-15.9,0.5-31.7-0.4-47.6
		c-0.3-4.3-0.4-8.7-1.1-13c-0.2-1.4,0.5-3.8-0.9-4.2c-24.7-6-22.4-9.6-26.2,0.5c-1.9,7.3-2.8,14.7-4.6,22
		c-3.4,15-7.6,29.9-13.6,44.1c-8.3,19.4-17.5,38.5-29.8,55.7c-6.6,8.4-12.9,16.6-22.3,22c-0.5,0.1-1,0.3-1.5,0.2
		c-2-0.3-3.5-1.6-4.8-3c-4.1-4.5-6.4-10.3-8.5-15.9c-0.8-2.6-1.7-5.1-2.4-7.7c-4.3-16.2-5.5-33.1-6.3-49.9
		c-0.5-18.7-0.4-37.5,2.3-56c1.3-9.3,2.7-18.5,4.5-27.7l0,0c3.5-18.6-22.8-23.6-26.3-5c-2,9.6-3.4,19.3-4.7,28.9
		c-3,20-3.1,40.3-2.6,60.5c0.9,18.5,2.3,37.1,6.9,55c0.8,3.2,1.9,6.4,2.9,9.6c1.1,2.9,2.1,5.9,3.4,8.7c4.6,10.3,11.5,20.7,22.1,25.6
		c2.7,1.3,5.7,1.8,8.6,2.6c3.2,0,6.4,0.4,9.5-0.1c13.6-2.2,24.5-12.5,33.1-22.5c2.5-2.9,4.7-5.9,7.1-8.9
		c11.3-15.6,20.3-32.6,28.2-50.1c-0.4,13.3-0.9,26.6-1.2,39.9c-0.3,11.7-0.6,23.4-0.9,35c-0.3,0.2-0.6,0.4-0.9,0.6
		c-11.9,7.8-22.3,17.7-31.2,28.8c-1.7,2.4-3.6,4.7-5.2,7.1c-7.8,11.5-13.5,24.4-15.2,38.2c-0.1,6.4-0.6,8.8,0.9,15.1
		c1.7,6.9,5.2,13.2,10.8,17.7c1.8,1.4,3.8,2.4,5.7,3.6c2,0.7,4,1.6,6.1,2.1c8.1,1.8,16.5,0,23.7-4c1.7-1,3.2-2.2,4.9-3.3
		c4.1-3.7,5.2-4.3,8.6-8.8c5.4-7.1,8.9-15.5,11.4-24c0.6-2.3,1.3-4.7,1.8-7c3-13.1,4.1-26.6,4.7-40c0.1-3.2,0.2-6.4,0.3-9.7
		c4.9-1.9,10-3,15.5-3.1C418.9,666.4,421.1,666.7,423.2,667.1z M368.5,719.2c-2.1,6.4-4.6,13.1-9.7,17.8c-0.6,0.6-1.3,1.1-2,1.6
		c-1.9,1.2-5.4,2.9-7.2,0.6c-1-3.3-0.8-6.8-0.5-10.2c1.7-9.1,5.9-17.6,11.1-25.2c1.3-1.8,2.7-3.6,4-5.4c2.9-3.6,6-7,9.3-10.2
		c-0.6,8.5-1.6,17.1-3.6,25.4C369.5,715.5,369,717.3,368.5,719.2z"
          />
          <path
            class="st0"
            d="M619.9,633.2c-22.3,2.7-44.7,5.8-66.7,10.5c-3.9,0.9-7.8,1.7-11.7,2.6c-17.6,4.2-34.9,9.6-52,15.6
		c-13.5,4.8-27.1,9.7-40.5,14.9c-6.1,2.4-12.1,5-18.3,7.2v0c-18,6-9.4,31.4,8.5,25.4c6.6-2.4,13.1-5.1,19.6-7.7
		c13.1-5.1,26.4-9.9,39.6-14.6c19.8-7.2,40.1-12.7,60.6-17.4c21.1-4.6,42.6-7.4,64-10.1C642,657.5,638.7,630.9,619.9,633.2z"
          />
          <path
            class="st0"
            d="M125.8,510.3L125.8,510.3c13.5-3.3,8.9-22.4-4.6-19.1c-13,3.7-26.3,6.2-39.5,8.8c-13.5,3-27.1,6-40.4,10
		c-2.2,0.6-4.4,1.4-6.5,2.2c-13,4.8-6.3,23.2,6.8,18.4c1.8-0.7,3.5-1.4,5.4-1.8c12.7-3.8,25.6-6.7,38.6-9.6
		C99.1,516.7,112.6,514.1,125.8,510.3z"
          />
          <path
            class="st0"
            d="M189.5,548.7L189.5,548.7c10.7-8.8-1.8-24-12.5-15.2c-8.5,6.4-17.1,12.7-25.4,19.4
		c-14.5,11.7-29.4,22.8-45.1,32.8c-3,1.9-6.1,3.7-9.2,5.6c-9,5.2-18,10.3-27,15.4c-12,6.9-2.2,24,9.8,17
		c9.2-5.3,18.4-10.4,27.5-15.7c3.3-2,6.6-4,9.8-6c16.2-10.4,31.6-21.8,46.5-33.9C172.3,561.5,181,555.2,189.5,548.7z"
          />
          <path
            class="st0"
            d="M180.6,634.3c-0.3,0.7-0.6,1.3-0.9,2c-0.6,1.4-1.6,4-2.3,5.5c-1.7,3.5-3.8,6.8-5.9,10
		c-5.9,9.1-12,18-17.8,27.2c-1.9,3-3.7,6.1-5.6,9.2c-7,12,10,21.9,17,9.9c1.7-2.9,3.4-5.7,5.2-8.6c5.8-9.2,11.9-18.1,17.9-27.2
		c3.8-6.1,7.5-12.3,10-19.1v0C204.4,630.7,186.9,621.9,180.6,634.3z"
          />
          <path
            class="st0"
            d="M702.7,168c7-8.7,14.3-17.1,21.2-25.9c4.3-5.7,2.3-3,6.1-8.1c8.3-11.1-7.5-22.9-15.8-11.7
		c-3.6,4.9-1.7,2.4-5.7,7.7c-2,2.5-5.8,7.4-7.8,9.8c-4.5,5.4-9.2,10.6-13.5,16.2h0C678.7,166.9,694.2,179,702.7,168z"
          />
          <path
            class="st0"
            d="M716.9,243.1c-11.1,8.3,0.7,24,11.8,15.7c13.3-8.9,27.5-16.5,41.9-23.6c15.6-6.9,31.5-13.1,47.2-19.7
		c3.8-1.6,7.6-3.3,11.2-5.2c12.3-6.5,3.1-23.9-9.2-17.3c-3.1,1.7-6.4,2.9-9.6,4.4c-16.1,6.7-32.3,13-48.2,20.1
		C746.4,225.2,731.2,233.4,716.9,243.1L716.9,243.1L716.9,243.1z"
          />
          <path
            class="st0"
            d="M808.7,313.9c-2.1,0.2-4.1,0.5-6.2,0.7c-12.6,1.5-25.2,3.1-37.9,4.1l0,0c-13.9,0.9-12.6,20.5,1.3,19.6
		c13-1,25.9-2.7,38.9-4.2c2.1-0.3,4.2-0.5,6.3-0.8C824.8,331.8,822.5,312.3,808.7,313.9z"
          />
          <path
            class="st0"
            d="M95,399.9c-5.7-0.9-11.3-2.1-17.1-2.3c-5.8-0.1-11.6,0.2-17.4,0.8h0c-13.7,2-11,21.4,2.8,19.4
		c4.7-0.4,9.5-0.7,14.3-0.6c4.8,0.3,9.5,1.2,14.2,2c2.7,0.4,1.2,0.2,4.4,0.4c13.9,0.5,14.6-19.1,0.8-19.6
		C96,400.1,96.7,400.1,95,399.9z"
          />
          <path
            class="st0"
            d="M97.9,186.5c7.4,8,15.5,15.2,23.7,22.3c0.9,0.7,1.8,1.4,2.7,2.2c10.8,8.7,23.2-6.5,12.4-15.3
		c-0.7-0.6-1.5-1.2-2.2-1.8c-7.8-6.7-15.6-13.6-22.5-21.2c-6.1-6.1-12.4-12-18.2-18.4c-9.1-10.5-23.9,2.5-14.8,12.9
		C84.9,173.9,91.6,180.1,97.9,186.5z"
          />
          <path
            class="st0"
            d="M174.3,125.5c2.3,7.8,4.3,15.8,6.7,23.6c4.2,13.2,22.9,7.4,18.7-5.9c-2.4-7.5-4.2-15.1-6.4-22.6
		c-2.5-9.6-4.8-19.2-7.5-28.7v0c-4.9-13-23.3-6.1-18.4,6.9C169.8,107.7,172,116.6,174.3,125.5z"
          />
          <path
            class="st0"
            d="M473.6,147.6c0-2.2,0-1,0-3.4c0.2-8.7,0.6-17.5,1.3-26.2c0.8-10,2.1-19.9,3.4-29.8h0
		c3-13.6-16.2-17.8-19.2-4.3c-1.6,10.8-2.9,21.6-3.8,32.4c-0.7,9.1-1.1,18.2-1.4,27.4c0,2.6,0,1.4,0,3.7
		C453.8,161.3,473.5,161.5,473.6,147.6z"
          />
          <path
            class="st0"
            d="M552.4,146.5c1-2.6,0.5-1.2,1.7-4.1c2.1-5.3,4-10.7,5.7-16.1c4.4-13.2-14.2-19.4-18.6-6.2
		c-1.6,5-3.3,10-5.3,14.8c-1.2,3-0.6,1.5-1.8,4.4C529.1,152.4,547.4,159.5,552.4,146.5z"
          />
          <path
            class="st0"
            d="M292.4,88.6c3.6,13.4,22.6,8.3,19-5.1c-1-3.7-1.9-7.5-2.2-11.3c-2-13.7-21.4-11-19.4,2.8
		C290.2,79.6,291.2,84.1,292.4,88.6z"
          />
          <path
            class="st0"
            d="M571.6,759.4L571.6,759.4c-3.8-13.4-22.7-8-18.9,5.4c1.8,8.2,3.6,16.3,5.3,24.5c2.9,13.6,22.1,9.5,19.2-4.1
		C575.4,776.5,573.5,767.9,571.6,759.4z"
          />
          <path
            class="st0"
            d="M715.2,766.5c-4.3-4.9-8.6-9.7-12.8-14.6c-8.5-9.9-16.6-20.2-25.3-30c-6.8-7.6-13.9-15-21.2-22.1l0,0
		c-9-10.5-24,2.2-14.9,12.8c7.3,7.3,14.6,14.8,21.5,22.5c8.5,9.6,16.4,19.7,24.8,29.4c4.3,5,8.7,9.9,13,14.9
		c5.2,6,10.4,11.9,15.8,17.8c9.4,10.2,23.9-3.1,14.4-13.3C725.4,778.2,720.2,772.4,715.2,766.5z"
          />
          <path
            class="st0"
            d="M762,678.4c-1.6-1.1-3.1-2.2-4.7-3.3c-10.1-7.3-20.3-14.5-30.2-22v0c-11.1-8.4-22.9,7.3-11.9,15.7
		c10.1,7.6,20.4,14.9,30.6,22.3c1.6,1.1,3.2,2.2,4.7,3.4C762,702.5,773.3,686.5,762,678.4z"
          />
          <path
            class="st0"
            d="M784.4,508.3c-1.3-0.4-2.7-0.7-4-1.1c-10.8-3-21.5-6.2-32.2-9.5c-7.7-2.3-15.5-4.8-22.9-8l0,0
		c-13.2-4.4-19.4,14.2-6.2,18.6c7.6,3.3,15.5,5.8,23.4,8.2c10.8,3.4,21.7,6.5,32.5,9.6c1.4,0.4,2.7,0.8,4.1,1.1
		C792.6,530.9,797.8,512,784.4,508.3z"
          />
          <path
            class="st0"
            d="M838.7,526.7c-4.5-1.5-9.1-3-13.5-4.9v0c-12.6-5.9-20.9,11.9-8.3,17.8c5.1,2.3,10.3,4,15.6,5.8
		C845.7,549.7,851.9,531.1,838.7,526.7z"
          />
          <path
            class="st0"
            d="M458,759.2c-1.3,5.5-2.7,10.9-4.1,16.4c-0.8,3.5-0.4,1.8-1.1,5.1c-2.7,13.6,16.5,17.5,19.3,3.9
		c0.5-2.8,0.2-1.3,0.9-4.3c1.4-5.6,2.8-11.2,4.1-16.8h0C480.2,749.9,461,745.6,458,759.2z"
          />
          <path
            class="st0"
            d="M252.1,733.4c-3.5,7.4-6.3,15.1-9.1,22.8c-2.9,7.3-5.3,14.8-7.9,22.2c-4.5,13.1,14.1,19.5,18.6,6.4
		c2.5-7.3,4.9-14.7,7.8-21.9c2.4-6.7,4.9-13.3,7.7-19.8h0C276,731.1,259,721.4,252.1,733.4z"
          />
          <path
            class="st0"
            d="M83,303.3c1.1,0.2,2.3,0.4,3.4,0.5c13.7,2.2,16.8-17.2,3.1-19.4c-0.9-0.1-1.9-0.3-2.8-0.4
		c-10.2-1.9-20.3-4-30.1-7.1c-8.3-2.3-16.8-4.2-25-6.9l0,0c-13.1-4.5-19.5,14.1-6.3,18.6c8.6,2.8,17.4,4.9,26.1,7.2
		C61.7,299.1,72.4,301.3,83,303.3z"
          />
        </g>
      </svg>
    </div>
    <div class="flex justify-center text-7xl font-bold"
    v-if="menu.is_checkout_collection_code"
    >
      {{ collectionCode }}
    </div>
    <div
      class="w-full text-center font-bold text-4xl"
      v-if="
        hasKiosk &&
        orderData.orderStatus != 'PaymentFailed' &&
        orderData.orderStatus != 'PaymentPending'
      "
    >
      {{ lang["thank_you"][language] }} {{ customerName }}!
    </div>    
    <div
      class="flex items-center flex-col"
      v-if="
        orderData.orderStatus != 'PaymentFailed' &&
        orderData.orderStatus != 'PaymentPending'
      "
    >
      <p v-if="!hasKiosk" class="text-5xl text-product-gray text-center">
        {{ lang["thank_you_message"][language] }}
      </p>
      <div
        v-if="
          menu['checkout_instruction' + '_' + language] &&
          !menu.is_festival_mode
        "
      >
        <p class="text-center">
          {{ menu["checkout_instruction" + "_" + language] }}
        </p>
        <p
          class="text-black text-3xl font-bold text-center"
          v-if="menu.is_checkout_collection_code"
        >
          {{ newFestivalCode }}
        </p>
      </div>
      <div
        v-else-if="
          menu.is_festival_mode && menu['checkout_instruction' + '_' + language]
        "
      >
        <p class="text-center" v-if="menu.is_checkout_collection_code">
          {{ menu["checkout_instruction" + "_" + language] }}
          <br />
          <span class="text-black text-3xl font-bold">{{
            newFestivalCode
          }}</span>
        </p>
        <p v-else class="text-center">
          {{ menu["checkout_instruction" + "_" + language] }}
          <br />
          <span class="text-black text-3xl font-bold"
            >#{{ orderData.orderId }}</span
          >
        </p>
      </div>
      <div
        v-else-if="
          menu.is_festival_mode &&
          !menu['checkout_instruction' + '_' + language]
        "
      >
        <p class="text-center">
          <span
            class="text-black text-3xl font-bold"
            v-if="menu.is_checkout_collection_code"
            >{{ newFestivalCode }}
          </span>
          <span v-else class="text-black text-3xl font-bold"
            >{{ lang["order"][language] }}: {{ menu.use_collection_code_as_order_number ? orderData.collection_code : `#${orderData.orderId}` }}</span
          >
        </p>
      </div>
      <div
        v-else-if="
          menu.is_checkout_collection_code &&
          !menu['checkout_instruction' + '_' + language] &&
          !menu.is_festival_mode
        "
      >
        <p class="text-center">
          <span
            class="text-black text-3xl font-bold"
            v-if="menu.is_checkout_collection_code"
            >{{ lang["order"][language] }}: {{ newFestivalCode }}
          </span>
          <span v-else class="text-black text-3xl font-bold"
            >{{ lang["order"][language] }}: {{ menu.use_collection_code_as_order_number ? orderData.collection_code : `#${orderData.orderId}` }}</span
          >
        </p>
      </div>
      <p v-else class="text-product-gray text-lg" :color="text">
        {{ lang["thank_you_message"][language] }}.
      </p>
    </div>
    <!-- Payment Failed title and description -->
    <div
      v-if="
            (hasKiosk || isMobileDevice) &&
            orderData.orderStatus != 'PaymentFailed' &&
            orderData.orderStatus != 'PaymentPending' &&
            (orderData.orderStatus === 'Paid' ||
            orderData.orderStatus === 'Synced') &&
            menu['order_succes_custom_message_' + language] !== ''
          "
      class="wrapper mx-auto px-4 py-5 mb-4 md:w-4/5 mt-6 rounded-large"
      :style="makeStyles(orderDetailInformationBackground, orderDetailInformationColor)"
    >
    <div class="flex items-center justify-center text-3xl">
        <IconInformation
          classes="h-5 w-5 mr-2"
          :stroke="iconKioskHomepageColor"/>
        {{menu['order_succes_custom_message_' + language]}}
      </div>
    </div>
    <div
      class="flex items-center flex-col mb-2 mt-4"
      v-if="orderData.orderStatus == 'PaymentFailed'"
    >
      <p class="text-4xl text-product-gray text-center">
        {{ lang["payment_failed"][language] }}
      </p>
      <p class="text-product-gray">{{ lang["retry_payment"][language] }}.</p>
    </div>
    <div
      class="flex items-center flex-col mb-2 mt-4"
      v-if="orderData.orderStatus == 'PaymentPending'"
    >
      <p class="text-4xl text-product-gray">
        {{ lang["payment_pending"][language] }}
      </p>
      <p class="text-product-gray">
        {{ lang["payment_still_processing"][language] }}
      </p>
    </div>
    <div
      class="wrapper mx-auto bg-gray-50 px-4 py-8 rounded-large mb-4 md:w-4/5 mt-6"
      :style="orderDetailOrderBackground"
    >
      <div
        :style="hasKiosk ? orderDetailOrderBackground : ''"
        :class="[
          '',
          hasKiosk ? 'bg-red-200 w-2/3 mx-auto mt-12' : 'border space-y-3',
        ]"
      >
        <div
          v-if="
            (currentOption || currentKioskMode) &&
            !hasKiosk &&
            this.menu.enable_delivery &&
            !this.isDelivery
          "
          class="md:block mt-4 mb-6 mx-auto w-auto inline-block"
        >
          <div
            class="bg-primary-100 rounded-xxl flex items-center justify-center"
            :style="btnThirdBackground"
            v-if="!hasKiosk && this.menu.enable_delivery && !this.isDelivery"
          >
            <IconTruck
            classes="h-9 p-1"
            :stroke="smallOrderTypeIconColor"
              v-if="currentKioskMode == lang['take_away'][language]"/>
            <IconHome v-else 
            classes="h-9 p-1"
            :stroke="smallOrderTypeIconColor"/>
            <p class="ml-4 text-new-primary font-bold">
              <!-- <span v-if="localStorage.getItem('currentOption')">hello</span> -->
              <!-- {{ currentKioskMode }} -->
              <span v-if="!hasKiosk && currentOption">
                {{ lang[currentOption][language] }}</span
              >
              <span v-else>{{ currentKioskMode }}</span>
            </p>
          </div>
        </div>
        <div>
          <h3
            :style="orderDetailOrderNumber"
            v-if="!menu.is_festival_mode"
            :class="[
              'text-center font-thin',
              hasKiosk ? 'text-4xl' : 'text-3xl',
            ]"
          >
            {{ lang["order"][language] }}
            <span class="text-bold"># {{ orderData.orderId }}</span>
          </h3>

          <h3 v-else :class="['font-semibold text-lg']">
            {{ lang["festival_order_text"][language] }}
          </h3>
          <!-- <p class="text-center opacity-90" :style="orderDetailOrderNumber">
            {{ menu.restaurant_address }}
          </p> -->

          <h3
            :class="['font-semibold text-lg text-center']"
            v-if="
              menu.pos_mode == 'take-out' &&
              !hasKiosk &&
              currentOption != 'Delivery' &&
              !menu.is_disable_takeaway_w_deliv
            "
          >
            <!-- {{ lang["take_away"][language] }} -->
            <span
              v-if="
                menu.pos_mode == 'take-out' &&
                menu.timeslots_mode != 'simple' &&
                menu.restaurant_address
              "
              >{{ menu.restaurant_address }}</span
            >
          </h3>
          <h3 v-if="!hasKiosk && stickerId != '0'" class="font-semibold text-md flex justify-start items-center">
              <ClipLoader size="27px" v-if="isTablesLoading"/>
              <span v-else-if="stickerId" class="text-3xl -mt-1">{{ lang["table"][language] }}  # {{ stickerId }}</span>

          </h3>
          <!-- <p
            :style="orderDetailOrderNumber"
            class="text-2xl font-bold"
            v-currency="totalPrice"
            v-if="hasKiosk"
          ></p> -->
        </div>
        <div class="mt-2 pb-2 font-lg text-xl font-medium">
          {{ lang["order_type"][language] }}: {{ kioskSetting }}
        </div>
        <div class="rounded-large py-2 px-2 bg-white">
          <table class="w-full">
            <tr
              v-for="(cartItem, index) in $_.uniqWith(
                orderData.OrderItems,
                $_.isEqual
              )"
              :key="index"
              :class="[
                'border-separate space-y-1',
                index !=
                $_.uniqWith(orderData.OrderItems, $_.isEqual).length - 1
                  ? 'border-b-1 border-gray-400'
                  : '',
              ]"
            >
              <td class="text-center">
                <h1
                  class="border-1 inline-flex rounded-md px-.7 text-xs md:text-sm mr-2 justify-center items-center w-8 h-6"
                  :style="orderDetailBorder"
                >
                  x{{ $_.countBy(orderData.OrderItems, cartItem).true || 0 }}
                </h1>
              </td>
              <td>
                <div class="flex">
                  <p :class="['text-xl font-medium']">
                    {{ cartItem["MenuItem"][`name_${language}`] }}
                  </p>
                </div>
                <div>
                  <small
                    class="text-gray-500"
                    v-for="(
                      additionGroup, index
                    ) in cartItem.OrderItemAdditions"
                    :key="additionGroup['AdditionGroup']['id']"
                  >
                    {{ additionGroup["Addition"][`name_${language}`] }}
                    <label v-if="index + 1 < cartItem.OrderItemAdditions.length"
                      >•</label
                    >
                  </small>
                </div>
              </td>
              <td>
                <h1
                  class="px-2 py-4 text-right font-bold text-lg"
                  v-currency="totalSum(cartItem)"
                  :style="orderDetailColor"
                ></h1>
              </td>
            </tr>
            <tr v-if="orderData.tip_amount||orderData.extra_charge_amount||orderData.discountAmount||orderData.loyalty_discount" class="border-t-2">
              <td class="text-center"></td>
              <td colspan="66%" class="abg-red-400">
                <div class="mt-4 leading-relaxed">
                  <!-- <h1 class="text-lg pb-4">
                      {{ lang[`extra_charges`][language] }}
                  </h1> -->
                  <div class="grid grid-cols-2" v-if="orderData.tip_amount">
                    <span class="text-gray-500 text-lg font-medium"> {{ lang['tip_amount'][language] }} </span>
                    <span v-currency="orderData.tip_amount" class="flex justify-end px-2 text-right text-md font-semibold text-gray-500"> </span>
                  </div>
                  <div class="grid grid-cols-2" v-if="orderData.extra_charge_amount">
                    <span class="text-gray-500 text-lg font-medium"> {{ lang['other_extra_charge'][language] }} </span>
                    <span v-currency="orderData.extra_charge_amount" class="flex justify-end px-2 text-right font-semibold text-gray-500"></span>
                  </div>
                  <div class="grid grid-cols-2" v-if="orderData.discountAmount">
                    <span class="text-gray-500 text-lg font-medium"> {{ lang['discount_amount'][language] }} </span>
                    <span v-currency="-1*orderData.discountAmount" class="flex justify-end px-2 text-right text-green-400 font-semibold"> </span>
                  </div>
                  <div class="grid grid-cols-2" v-if="orderData.loyalty_discount">
                    <span class="text-gray-500 text-lg font-medium"> {{ lang['loyalty_discount'][language] }} </span>
                    <span v-currency="-1*orderData.loyalty_discount" class="flex justify-end px-2 text-right text-green-400 font-semibold"> </span>
                  </div>
                </div>
              </td>
            </tr>
          </table>
        </div>
        <div class="px-4">
          <p
            class="text-md text-right pt-2 font-semibold"
            :style="orderDetailOrderNumber"
          >
            {{ lang["total"][language] }}
          </p>
          <h1
            class="text-right text-2xl font-semibold"
            :style="orderDetailOrderNumber"
            style="margin: 0px"
            v-currency="totalPrice"
          ></h1>
        </div>
        <div v-if="orderData.note" :class="['rounded text-sm']"
            :style="orderDetailOrderNumber"
            >
          <p>{{ lang["note"][language] }}: {{ orderData.note }}</p>
        </div>
      </div>
      <div
        v-if="orderData.securityToken"
        class="flex flex-col mb-4 text-lg text-center font-medium border border-green-300 bg-green-100 w-full py-1 px-2 rounded text-green-500 align-middle"
      >
        <small class="text-xs">Security Token</small>
        <span>{{ orderData.securityToken }}</span>
      </div>

      <div class="flex justify-center">
        <button
          v-if="orderData.orderStatus == 'PaymentPending'"
          @click="$router.go($router.currentRoute)"
          class="w-1/2 text-xl mt-6 p-4 bg-red-200 mr-2 flex justify-center text-red-700 transition duration-300 hover:bg-red-200 rounded-full items-center"
          :style="makeStyles(hasKiosk && secondButtonRadius , btnSecondBackground , btnSecondText)"
        >
          {{ "Reload" }}
        </button>
        <button
          @click="createNewOrder()"
          v-if="orderData.orderStatus === 'PaymentPending'"
          type="button"
          :class="[
            {
              'w-1/3 flex': orderData.orderStatus != 'PendingPayment',
            },
            hasKiosk ? 'w-1/3' : 'w-9/12',
            'text-xl mt-6 p-4 flex justify-center transition duration-300 rounded-large border bg-new-primary text-white items-center',
          ]"
          :style="hasKiosk && mainButtonRadius + btnMainBackground + btnMainText"
        >
          {{ lang["create_new_order"][language] }}
        </button>
        <button
          v-if="orderData.orderStatus == 'PaymentFailed'"
          @click="retryPaymentHandler"
          class="text-xl mt-6 p-4 bg-primary-dark mr-2 flex justify-center py-2 text-white rounded-large transition duration-300 hover:bg-primary items-center"
          :class="[hasKiosk ? 'rounded-large rounded' : 'w-1/2 rounded-full']"
          :style="makeStyles(hasKiosk && mainButtonRadius , btnMainBackground , btnMainText)"
        >
          {{ lang["retry_payment"][language] }}
        </button>
        <button
          @click="createNewOrder()"
          :disabled="isTablesLoading"
          v-if="
            orderData.orderStatus !== 'PendingPayment' &&
            orderData.orderStatus !== 'PaymentPending'
          "
          type="button"
          class="text-xl mr-2 text-primary-400"
          :class="[
            {
              flex: orderData.orderStatus != 'PendingPayment',
            },
            isTablesLoading&&'cursor-not-allowed opacity-80',
            'w-8/12 text-xl mt-6 p-4 flex justify-center transition duration-300 rounded-full border bg-white items-center',
          ]"
          :style="makeStyles(hasKiosk && mainButtonRadius , btnMainBackground , paymentBtnText)"
        >
          {{ lang["create_new_order"][language] }}
        </button>
        <div v-else class="mt-6">
          <TimeOutButton
            v-if="
              orderData.orderStatus != 'PaymentFailed' &&
              orderData.orderStatus != 'PaymentPending'
            "
            :cancelTime="orderData.orderStatus == 'PaymentFailed' ? 25 : 10"
            @click="createNewOrder"
            @timedOut="createNewOrder"
            >{{ lang["create_new_order"][language] }}</TimeOutButton
          >
        </div>
      </div>
    </div>
    <!-- Message: Collect ticket  -->
    <div
      v-if="
            hasKiosk &&
            (orderData.orderStatus === 'Paid' ||
            orderData.orderStatus === 'Synced')
          "
      class="wrapper mx-auto px-4 py-5 mb-4 md:w-4/5 mt-6 rounded-large"
      :style="orderDetailOrderBackground"
    >
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" :stroke="buttonImgColors" stroke-width="2" stroke-linecap="square" stroke-linejoin="arcs" class="inline">
      <path d="M12 5v13M5 12l7 7 7-7"/>
      </svg>
      <span class="font-bold">
        {{ lang["collect_ticket"][language] }}
      </span>
    </div>
    <modal
      name="retry-payment"
      width="90%"
      height="auto"
      :adaptive="true"
      scrollable
    >
      <div class="mt-4">
        <Payment />
      </div>
    </modal>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
import moment from "moment";
import Payment from "../views/Payment";
import TimeOutButton from "../components/TimeOutButton.vue";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";

import { GET } from "../utils";
import IconHome from "../components/icons/iconHome.vue";
import IconTruck from "../components/icons/iconTruck.vue";
import IconInformation from '../components/icons/iconInformation.vue';
import axios from 'axios';

export default {
  data() {
    return {
      lang: lang,
      // stickerId: "",
      checkingPaymentStatus: "Betaling controleren, even geduld...",
      currentOption: localStorage.getItem("currentOption"),
      newFestivalCode: "",
      customerName: "",
      kioskSetting: localStorage.getItem("kioskOption"),
      totalPrice: "",
      ticketPrint: true,
      collectionCode: "",
    };
  },
  components: { Payment,ClipLoader, TimeOutButton, IconHome, IconTruck, IconInformation },
  computed: {
    ...mapGetters([
      "orderData",
      "language",
      "menuHash",
      "menu",
      "theme",
      "currentKioskMode",
      "hasKiosk",
      "isDelivery",
      "isMobileDevice",
      "identificationFormData",
    ]),
      ...mapGetters("Cart", [
        "stickerId",
        "isTablesLoading",
        "isTimeSlotsLoading",
        "timeSlots",
      ]),
    ...mapGetters("Theme", [
      "mainSectionTopRadius",
      "mainButtonRadius",
      "btnMainBackground",
      "btnMainText",
      "btnThirdText",
      "text",
      "btnSecondBackground",
      "secondButtonRadius",
      "btnSecondText",
      "btnThirdBackground",
      "thankYouImgColor",
      "orderDetailSuccesfullPayment",
      "orderDetailOrderNumber",
      "orderDetailOrderBackground",
      "orderDetailInformationBackground",
      "orderDetailInformationColor",
      "orderDetailBorder",
      "paymentBtnText",
      "orderDetailColor",
      "buttonImgColors",
      "orderDetailPageBackground",
      "smallOrderTypeIconColor",
    ]),
  },
  methods: {
    retryPaymentHandler() { 
      this.$modal.show('retry-payment');
      this.$store.commit("Cart/updateIsCartOverviewShow", true);
      sessionStorage.setItem("orderChunksExists", true);
    },
    totalSum(cartItem) {
      if (cartItem.OrderItemAdditions?.length) {
        return cartItem.OrderItemAdditions.reduce((acc, el) => {
          acc += el.Addition?.price || 0;
          return acc;
        }, cartItem.MenuItem?.price || 0);
      }
      return cartItem.MenuItem?.price || 0;
    },
    // creates a new order
    createNewOrder() {
      sessionStorage.removeItem("comoMember");
      sessionStorage.removeItem("comoMemberCode");
      sessionStorage.setItem("isLoyaltyMember",false);
      this.$store.commit("updateMember", "");
      this.$store.commit("updateCustomIdentifier", "");
      this.$store.commit("Cart/removeOrderChunks");
      sessionStorage.setItem(
        "sessionId",
        [...Array(30)].map(() => Math.random().toString(36)[2]).join("")
      );
      if (this.menu.pos_mode == "take-out" && !this.hasKiosk) {
        location.href = `/${this.menuHash}`;
      } else if (this.hasKiosk) {
        if (this.$route.query.printerIp) {
          location.href = `/${this.menuHash}/start/kiosk?mode=kiosk&printerIp=${this.$route.query.printerIp}`;
        } else {
          location.href = `/${this.menuHash}/start/kiosk?mode=kiosk`;
        }
      } else {
        location.href = `/${this.menuHash}/${
          this.stickerId
          // this.$route.params.stickerId != "0"
          //   ? this.$route.params.stickerId
          //   : parseInt(localStorage.getItem("stickerId"))
        }`;
      }
    },
    // get the order item details
    async getOrderDetails() {
      const menuHash = this.$route.params.menuHash;
      const sessionId = this.$route.query.sessionId;
      if(this.hasKiosk){
        const {
          data: { OrderAPI },
        } = await GET.MENU_ITEMS({
          menuHash,
          sessionId,
        });

        this.$store.commit("updateOrderedData", await OrderAPI);
      }
      else{
          const {
          data: { OrderAPI },
        } = await GET.MENU_ITEMS({
          menuHash,
          sessionId,
        });

        this.$store.commit("updateOrderedData", await OrderAPI);
      }
    },
    async reloadOrderDetails() {
      /**
       * Poll for orderstatus as long if payment is pending
       */

      // amount of seconds between intervals
      const seconds = 3;

      // x times interval happens
      const intervalTimes =
        process.env.NODE_ENV === "development" ? undefined : undefined;

      const interval = setInterval(async () => {
        // fetch orderdetails (results are stored in state)
        await this.getOrderDetails();

        // stop interval if payment not pending (anymore) or max intervals are reached
        if (
          this.orderData.orderStatus !== "PaymentPending" ||
          this.paymentPendingRetry >= intervalTimes
        ) {
          clearInterval(interval);
        } else if (intervalTimes) {
          // set retry amount so max intervals can be reached (not in dev environement)
          this.paymentPendingRetry += 1;
        }
      }, seconds * 1000);
    },
    // connect to the printer Ip and the EPOS device
    connect() {
      let PrinterIpAddress = localStorage.getItem("printerIp");
      let ePosDev = new epson.ePOSDevice(); // eslint-disable-line
      //Connects to a device
      ePosDev.connect(PrinterIpAddress, "8008", this.callback_connect);
    },

    callback_connect(resultConnect) {
      let ePosDev = new epson.ePOSDevice(); // eslint-disable-line

      if (resultConnect == "OK" || resultConnect == "SSL_CONNECT_OK") {
        //Retrieves the Printer object
        ePosDev.createDevice(
          "local_printer",
          ePosDev.DEVICE_TYPE_PRINTER,
          { crypto: false, buffer: false },
          this.callback_createDevice
        );
      }
    },

    callback_createDevice(deviceObj, retcode) {
      let printer = deviceObj;
      if (retcode == "OK") {
        console.log("callback_createDevice success => printer, retcode", printer, retcode);
        printer.timeout = 60000;
        //Registers an event
        printer.onstatuschange = function (res) {
          alert(res.success);
        };
        printer.onbatterystatuschange = function (res) {
          alert(res.success);
        };
        this.print();
      } else {
          try {
            let arr = [];
            arr.push("Create Printer Device Failed");
            arr.push("device Object", deviceObj);
            arr.push("ret/Status Code", retcode);
            arr.push("session Id", this.$route.query.sessionId);
            let data = {
              MenuHash: this.menuHash,
              Dump: JSON.stringify(arr),
            };
            
            axios.post(
              `${process.env.VUE_APP_API_BASE_PATH}/PostErrorDump`,
              data
            );

          } catch (error) {
            // console.error()
          }
        if (this.ticketPrint) {
          this.ticketPrint = false;
          this.print();
        }
      }
    },

    // 'design' the ticket with the builder and print it
    print() {
      let PrinterIpAddress = localStorage.getItem("printerIp");
      let address = `http://${PrinterIpAddress}/cgi-bin/epos/service.cgi?devid=local_printer&timeout=8000`;
      let ePosDev = new epson.ePOSDevice(); // eslint-disable-line
      let builder = new epson.ePOSBuilder(); // eslint-disable-line
      let epos = new epson.ePOSPrint(address); // eslint-disable-line

      // date generator
      let dateTime = moment().format('YYYY-MM-DD H:m:s');


      builder.addLogo(32, 32);
      builder.addTextLang("en");

       
      builder.addTextSize(7, 7);
      builder.addTextStyle(true, false, false);

      if(this.menu.is_collection_code_enabled) {
      builder.addText(`${this.orderData.collection_code}\n`); // Collection_code if enabled
      }

      builder.addTextStyle(false, false, false);
      builder.addTextSize(3, 3);
      builder.addText(`\n${this.menu[`name_${this.language}`]}\n`);
      builder.addTextSize(2, 2);

      if(this.customerName){
      builder.addText(`${this.customerName}\n`);
      }

      builder.addTextSize(1, 1);
      builder.addText(`\n#${this.orderData.orderId}\n`);
      builder.addText(`${dateTime}\n\n`);

      this.orderData.OrderItems.map((x) => {
        builder.addTextSize(1, 1);
        builder.addTextStyle(undefined, false, true);
        builder.addText(
          `${
            x.MenuItem[`name_${this.language}`]
          } 1x €${x.MenuItem.price.toFixed(2)}\n`
        );
        let space = x.OrderItemAdditions.length ? "\n \n" : "\n";
        builder.addTextSize(1, 1);
        builder.addTextStyle(undefined, false, false);
        builder.addText(
          `${x.OrderItemAdditions.map(
            (y) => y.Addition[`name_${this.language}`]
          )} ${space}`
        );
      });
      builder.addTextSize(2, 2);
      builder.addText(
        `\n${lang["total"][this.language]}: €${this.totalPrice.toFixed(2)}\n`
      );
      builder.addTextSize(1, 1);
      builder.addText(`${localStorage.getItem("kioskOption")}\n`);
      builder.addHLine(100, 200, builder.LINE_THIN_DOUBLE);
      builder.addText(`(Dit is geen geldig BTW-kasticket)\n \n`);
      builder.addCut(builder.CUT_FEED);

      //Acquire the print document
      let request = builder.toString();
      epos.onreceive = function (res) {
        //When the printing is not successful, display a message
        if (!res.success) {
          alert("A print error occurred");
        }
      };
      epos.send(request);
    },
  },
  beforeRouteLeave() {
    this.createNewOrder();
  },
  mounted() {
    localStorage.setItem('isRetryPayment', 'false');

    this.reloadOrderDetails();

    // save the selected language for the order details page
    if (localStorage.getItem("language")) {
      this.$store.commit("changeLanguage", localStorage.getItem("language"));
    }
    this.$store.commit("updateProcessBarCurrentItem", 9);
    if (!this.menuHash) {
      if (this.$route.query.sessionId) {
        sessionStorage.setItem("sessionId", this.$route.query.sessionId);
      }
      this.$store.commit("updateMenuHash", this.$route.params.menuHash);
      this.$store.dispatch("GET_MENU_ITEMS").then((response) => {
        /** When order isn't successful then the item would be added back to the cart. */
        this.totalPrice = response.data.OrderAPI.amount;
        this.customerName = response.data.OrderAPI.Customer.fullName;
        this.newFestivalCode = response.data.OrderAPI.collectionCode;
        this.collectionCode = response.data.OrderAPI.collection_code;
        if (response.data.OrderAPI.orderStatus != "Paid") {
          response.data.OrderAPI.OrderItems.forEach((element) => {
            let menuItem = element.MenuItem;
            menuItem["OrderItemAdditions"] = element.OrderItemAdditions;
            this.$store.commit("Cart/addItem", menuItem);
          });
        }

        // Como submit purchase call when loyalty discount is not zero and order status is paid
        if(response.data.OrderAPI.loyalty_discount != 0 && response.data.OrderAPI.orderStatus == 'Paid')
          this.$store.dispatch("COMO_SUBMIT_PURCHASE")

        if (!this.isTablesLoading) {
          /** Getting tables from the API and changing the  */
          this.$store.dispatch("Cart/GET_TABLES").then((tableResponse) => {
            let tableObject = this.$_.findLast(tableResponse.data, (item) => {
              return item.Id == response.data.OrderAPI.TableId;
            });
            if (tableObject && tableObject.stickerId) {
              this.$store.commit("Cart/updateStickerId", tableObject.stickerId);
            }
            this.$store.commit("updateIsThemeLoading", false);
          }).catch(err => {
            this.$store.commit("updateIsThemeLoading", false);
            console.err(err);
          });
        }
        if (!this.isTimeSlotsLoading && !this.timeSlots.length) {
          this.$store.dispatch("Cart/GET_TIME_SLOTS").then((timeSlotResponse) => {
            //This one is not being use remove it during refactoring
            let timeSlotObject = this.$_.findLast(
              timeSlotResponse.data,
              (item) => {
                return item.Id == response.data.OrderAPI.TimeSlot;
              }
            );
            // this.stickerId = timeSlotObject.stickerId;
            if (timeSlotObject && timeSlotObject.stickerId) {
              // no sticker Id detail found in time Slots
              this.$store.commit("Cart/updateStickerId", timeSlotObject.stickerId);
            }
          });
        }
      });
    }
    /**
     * Reloading the page every 30 seconds if the payment is pending.
     * Just to be sure that it remains pending if not synced.
     */
    var interval = "";
    setTimeout(() => {
      if (this.orderData.orderStatus == "PaymentPending") {
        if (localStorage.getItem("paymentPendingRetry")) {
          if (parseInt(localStorage.getItem("paymentPendingRetry")) <= 4) {
            interval = setInterval(() => {
              let newRetryCounter =
                parseInt(localStorage.getItem("paymentPendingRetry")) + 1;
              localStorage.setItem("paymentPendingRetry", newRetryCounter);
              if (newRetryCounter > 4) {
                this.checkingPaymentStatus = "";
                clearInterval(interval);
              }
              location.reload();
            }, 30000);
          }
        } else {
          localStorage.setItem("paymentPendingRetry", 1);
        }
      }
    }, 1000);
  },
  created() {
    if (this.hasKiosk) {
      this.$store.commit(
        "updateSessionId",
        sessionStorage.getItem("sessionId")
      );
    }
  },
  updated() {
    this.totalPrice = this.orderData.amount
    // print the ticket if status is paid or synced (only works if there is an printerIP in the url)
    if (
      this.orderData.orderStatus === "Paid" ||
      this.orderData.orderStatus === "Synced"
    ) {
      console.log("Connect printer method call");
      this.connect();
    }
  },
};
</script>

<style scoped>
.thankyouicon {
  height: 250px;
}
</style>
